<template>
  <div>
    <div class="store-locator-banner__inputs-container">
      <div class="form-group">
        <label
          for="zipcode"
          class="input-text__label is-sr-only"
        >
          {{ zipcodeLabel }}
        </label>
        <input
          id="zipcode"
          ref="zipcode"
          v-model="zipcode"
          class="input-text input-text--show-placeholder"
          type="text"
          name="zipcode"
          aria-describedby="zipcode-errors"
          :placeholder="zipcodeLabel"
          @change="dirtyZipCode"
          @keypress="isNumber($event)"
        >
        <div
          id="zipcode-errors"
          class="errors-log"
        >
          <span v-if="zicodeError"><slot name="zipcode-error" /></span>
        </div>
      </div>

      <div class="form-group form-group--select">
        <label
          for="products"
          class="is-sr-only"
        >
          <slot name="product-label" />
        </label>
        <select
          id="products"
          ref="product"
          v-model="product"
          name="products"
          class="input-text"
          aria-describedby="products-errors"
          aria-required="true"
          @change="dirtyProduct"
        >
          <option
            disabled
            selected
            value=""
          >
            <slot name="product-label" />
          </option>
          <option
            v-for="({ id, value }) in products"
            :key="id"
            :value="id"
            v-text="value"
          />
        </select>
        <div
          id="products-errors"
          class="errors-log"
        >
          <span v-if="productError"><slot name="product-error" /></span>
        </div>
      </div>
    </div>

    <button
      class="btn btn--secondary"
      @click.prevent="submit"
    >
      <slot name="cta-label" />
    </button>
  </div>
</template>

<script>
  import { AnalyticsHandler } from '@Foundation/analyticsHandler';

  export default {
    name: 'StoreLocatorBanner',
    props: {
      ctaUrl: { type: String, required: true },
      pageCategory: {
        default: '',
        type: String,
      },
      products: { type: Array, required: true },
      zipcodeLabel: { type: String, required: true },
      openInNewWindow: { type: Boolean, required: false, default: false }
    },
    data() {
      return {
        zipcode: '',
        zipcodeDirty: false,
        product: '',
        productDirty: false
      };
    },
    computed: {
      zicodeError() {
        return this.zipcode === '' && this.zipcodeDirty;
      },
      productError() {
        return this.product === '' && this.productDirty;
      },
      allFilled() {
        return !this.zicodeError && !this.productError;
      },
      urlTo() {
        return `${this.ctaUrl}?zip=${this.zipcode}&id=${this.product}`;
      },
      target() {
        return this.openInNewWindow ? '_blank' : '_self';
      },
      selectedProduct() {
        return (this.product && this.products.find((product) => product.id === this.product)) || {};
      },
      taggingEvent() {
        const product = this.selectedProduct;
        product.category = product.category ? product.category.toLowerCase() : '';
        product.name = product.value.toLowerCase();

        return {
          event: 'uaevent',
          ecommerce: 'undefined',
          eventCategory: 'store locator',
          eventAction: 'find a salon teaser',
          eventLabel: `${this.pageCategory.toLowerCase()}::${product.ean}::${product.name}`,
          event_name: 'store_locator',
          product_info: `${product.name}::${product.id}`,
          searchCategory: product.category,
          search_category: product.category,
          searchKeyword: product.name,
          search_keyword: product.name,
        };
      }
    },
    mounted() {
    },
    methods: {
      submit() {
        this.setAllDirty();

        if (!this.zipcode) {
          this.$refs.zipcode.focus();
          return;
        }

        if (!this.product) {
          this.$refs.product.focus();
          return;
        }

        if (this.allFilled) {
          this.sendTaggingEvent();
          window.open(this.urlTo, this.target);
        }
      },
      setAllDirty() {
        this.zipcodeDirty = true;
        this.productDirty = true;
      },
      dirtyZipCode() {
        this.zipcodeDirty = true;
      },
      dirtyProduct() {
        this.productDirty = true;
      },
      isNumber: function(evt) {
        evt = (evt) ? evt : window.event;
        var charCode = (evt.which) ? evt.which : evt.keyCode;
        if ((charCode > 31 && (charCode < 48 || charCode > 57))) {
          evt.preventDefault();
        } else {
          return true;
        }
      },
      sendTaggingEvent() {
        AnalyticsHandler.pushDataLayer(this.taggingEvent);
      }
    }
  };
</script>
